var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexibilities"},[(_vm.getScaffold.availableBfactors.length == 0)?_c('FlexibilityPanel',{attrs:{"protein":_vm.getScaffold}}):_c('FlexibilityVizualization',{attrs:{"protein":_vm.getScaffold}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }